import axios from "axios";
import BASE_URL from "../../config";

const getAuthHeader = () => {
  const tokenData = JSON.parse(localStorage.getItem("authUser") || "{}");
  return {
    Authorization: `Bearer ${tokenData.accessToken}`,
    'Content-Type': 'application/json'
  };
};

export const getBusinesses = async (filter = {}) => {
  try {
    const response = await axios.post(`${BASE_URL}/api/Business/get`, filter, {
      headers: getAuthHeader(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching businesses:", error);
    throw error;
  }
};

export const saveBusiness = async (business) => {
  const headers = getAuthHeader();
  
  // If business is FormData (for file upload), don't set Content-Type
  if (business instanceof FormData) {
    const response = await axios.post(`${BASE_URL}/api/Business/save`, business, {
      headers: {
        ...headers,
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } else {
    // For regular JSON data
    const response = await axios.post(`${BASE_URL}/api/Business/save`, business, {
      headers: {
        ...headers,
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  }
};
